import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.some";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { createContext, useContext, useReducer } from 'react';
import { avSlotMachineApi } from '@availity/api-axios';
import { useEffectAsync } from '@availity/hooks';
import { spacesReducer, INITIAL_STATE, sanitizeSpaces, isFunction } from './helpers';
export var getAllSpaces = function getAllSpaces(query, clientId, variables, _spaces) {
  var _ref, spaces, totalCount, page, perPage, unionedSpaces, vars;

  return _regeneratorRuntime.async(function getAllSpaces$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (_spaces === void 0) {
            _spaces = [];
          }

          if (clientId) {
            _context.next = 3;
            break;
          }

          throw new Error('clientId is required');

        case 3:
          _context.next = 5;
          return _regeneratorRuntime.awrap(avSlotMachineApi.create({
            query: query,
            variables: variables
          }, {
            headers: {
              'X-Client-ID': clientId
            }
          }));

        case 5:
          _ref = _context.sent;
          spaces = _ref.data.data.spaces;
          totalCount = spaces.totalCount, page = spaces.page, perPage = spaces.perPage;
          unionedSpaces = _spaces.concat(spaces.spaces);

          if (!(totalCount > page * perPage)) {
            _context.next = 12;
            break;
          }

          vars = _objectSpread({}, variables, {
            page: page + 1
          });
          return _context.abrupt("return", getAllSpaces(query, clientId, vars, unionedSpaces));

        case 12:
          return _context.abrupt("return", unionedSpaces);

        case 13:
        case "end":
          return _context.stop();
      }
    }
  });
};
export var SpacesContext = createContext();
export var useSpacesContext = function useSpacesContext() {
  return useContext(SpacesContext);
};

var Spaces = function Spaces(_ref2) {
  var query = _ref2.query,
      variables = _ref2.variables,
      clientId = _ref2.clientId,
      spaceIds = _ref2.spaceIds,
      payerIds = _ref2.payerIds,
      children = _ref2.children,
      spacesFromProps = _ref2.spaces;

  var _useReducer = useReducer(spacesReducer, INITIAL_STATE),
      _useReducer$ = _useReducer[0],
      spaces = _useReducer$.spaces,
      loading = _useReducer$.loading,
      error = _useReducer$.error,
      dispatch = _useReducer[1]; // NOTE: we do not want to query slotmachine by payerIDs and spaceIDs at the same time
  // because slotmachine does an AND on those conditions. We want OR


  useEffectAsync(function _callee() {
    var filteredSpaceIDs, filteredPayerIDs, _spaces, vars, spacesBySpaceIDs, _vars, spacesByPayerIDs;

    return _regeneratorRuntime.async(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            dispatch({
              type: 'LOADING',
              loading: true
            }); // Filter out dupes and ids that we already have the space for

            filteredSpaceIDs = spaceIds.filter(function (id, i) {
              return spaceIds.indexOf(id) === i;
            }).filter(function (id) {
              return !spaces.some(function (spc) {
                return spc && spc.id === id;
              });
            }).filter(function (id) {
              return !spacesFromProps.some(function (spc) {
                return spc && spc.id === id;
              });
            });
            filteredPayerIDs = payerIds.filter(function (id, i) {
              return payerIds.indexOf(id) === i;
            }).filter(function (id) {
              return !spaces.some(function (spc) {
                return spc && spc.payerIDs && spc.payerIDs.some(function (pId) {
                  return pId === id;
                });
              });
            }).filter(function (id) {
              return !spacesFromProps.some(function (spc) {
                return spc && spc.payerIDs && spc.payerIDs.some(function (pId) {
                  return pId === id;
                });
              });
            });
            _spaces = [];

            if (!(filteredSpaceIDs.length > 0)) {
              _context2.next = 11;
              break;
            }

            vars = _objectSpread({}, variables, {
              ids: filteredSpaceIDs
            });
            _context2.next = 9;
            return _regeneratorRuntime.awrap(getAllSpaces(query, clientId, vars, spaces));

          case 9:
            spacesBySpaceIDs = _context2.sent;
            _spaces = _spaces.concat(spacesBySpaceIDs);

          case 11:
            if (!(filteredPayerIDs.length > 0)) {
              _context2.next = 17;
              break;
            }

            _vars = _objectSpread({}, variables, {
              payerIDs: filteredPayerIDs
            });
            _context2.next = 15;
            return _regeneratorRuntime.awrap(getAllSpaces(query, clientId, _vars, spaces));

          case 15:
            spacesByPayerIDs = _context2.sent;
            _spaces = _spaces.concat(spacesByPayerIDs);

          case 17:
            dispatch({
              type: 'SPACES',
              spaces: _spaces
            });
            _context2.next = 23;
            break;

          case 20:
            _context2.prev = 20;
            _context2.t0 = _context2["catch"](0);
            dispatch({
              type: 'ERROR',
              error: _context2.t0.message
            });

          case 23:
          case "end":
            return _context2.stop();
        }
      }
    }, null, null, [[0, 20]]);
  }, [payerIds, spaceIds]);
  var spacesForProvider = sanitizeSpaces(spaces.concat(spacesFromProps));
  return React.createElement(SpacesContext.Provider, {
    value: {
      spaces: spacesForProvider,
      loading: loading,
      error: error
    }
  }, isFunction(children) ? function () {
    return children({
      spaces: spacesForProvider,
      loading: loading,
      error: error
    });
  }() : children);
};

export var useSpaces = function useSpaces() {
  for (var _len = arguments.length, ids = new Array(_len), _key = 0; _key < _len; _key++) {
    ids[_key] = arguments[_key];
  }

  var _ref3 = useContext(SpacesContext) || {},
      _ref3$spaces = _ref3.spaces,
      spaces = _ref3$spaces === void 0 ? [] : _ref3$spaces;

  var idsIsEmpty = !ids || ids.length === 0;
  var callerIsExpectingFirstSpace = ids && ids.length === 1 && ids[0] === undefined;

  if (callerIsExpectingFirstSpace && spaces.length > 1) {
    // eslint-disable-next-line no-console
    console.warn("You did not pass an ID in to find a space, and there is more than 1 space in the space array. Returning all.");
  }

  var shouldReturnAllSpaces = idsIsEmpty || callerIsExpectingFirstSpace;

  if (shouldReturnAllSpaces) {
    return spaces;
  } // Try to match by space id first, else match by payer id


  var filteredSpaces = ids.map(function (id) {
    var _spaces$filter = spaces.filter(function (s) {
      return s.id === id;
    }),
        spc = _spaces$filter[0];

    if (!spc) {
      var _spaces$filter2 = spaces.filter(function (s) {
        return (s.payerIDs || []).some(function (p) {
          return p === id;
        });
      });

      spc = _spaces$filter2[0];
    }

    return spc;
  });
  return filteredSpaces;
};
Spaces.defaultProps = {
  query: "\n    query($ids: [String!], $payerIDs: [String!], $types: [String!], $page: Int){\n      spaces(ids: $ids, payerIDs: $payerIDs, types: $types, page: $page){\n        totalCount\n        perPage\n        page\n        spaces{\n          id\n          name\n          description\n          link {\n            url\n          }\n          payerIDs\n          parentIDs\n          metadata{\n            name\n            value\n          }\n          images{\n            name\n            value\n          }\n          url\n        }\n      }\n    }\n  ",
  variables: {
    types: ['space']
  },
  spaceIds: [],
  payerIds: [],
  spaces: []
};
export default Spaces;